



















































































































































import { Vue, Component } from 'vue-property-decorator';
import { Toast, Popup, Picker, Icon, Checkbox } from 'vant';
import SyEditor from '@/components/SyEditor.vue';
import Uploader from '@/components/Uploader.vue';
import { register } from '../api';

Vue.use(Toast).use(Popup).use(Picker).use(Icon).use(Checkbox);

@Component({
  components: {
    SyEditor,
    Uploader,
  },
})
export default class Register extends Vue {
  district = '请选择区县';
  schoolName = '';
  grade = '';
  author = '';
  phone = '';
  teacherName = '';
  title = '';
  showPicker = false;
  showAgreement = false;
  columns = [
    '万州区',
    '黔江区',
    '涪陵区',
    '渝中区',
    '大渡口区',
    '江北区',
    '沙坪坝区',
    '九龙坡区',
    '南岸区',
    '北碚区',
    '綦江区',
    '大足区',
    '渝北区',
    '巴南区',
    '长寿区',
    '江津区',
    '合川区',
    '永川区',
    '南川区',
    '璧山区',
    '铜梁区',
    '潼南区',
    '荣昌区',
    '开州区',
    '梁平区',
    '武隆区',
    '城口县',
    '丰都县',
    '垫江县',
    '忠县',
    '云阳县',
    '奉节县',
    '巫山县',
    '巫溪县',
    '石柱县',
    '秀山县',
    '酉阳县',
    '彭水县',
    '两江新区',
    '高新区',
  ];
  cropConfig: any = {
    width: 800,
    height: 540,
  };
  userAccept = false;

  checkForm() {
    const mobileReg = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
    if (this.district === '请选择区县') {
      Toast('请选择区县');
      return false;
    } else if (!this.title) {
      Toast('请填写作品名称');
      return false;
    } else if (!this.author) {
      Toast('请填写作者姓名');
      return false;
    } else if (!this.phone || !mobileReg.test(this.phone)) {
      Toast('请填写正确的手机号');
      return false;
    } else if (!(this.$refs.editor as SyEditor).content) {
      Toast('请填写作品简介');
      return false;
    } else if ((this.$refs.editor as SyEditor).getWordCount().wordCount > 200) {
      Toast('作品描述字数超过200字限制');
      return false;
    } else if (!this.userAccept) {
      Toast('请阅读并同意承诺书');
      return false;
    } else {
      return true;
    }
  }

  onBlur() {
    // const u = navigator.userAgent;
    // const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    // if (isiOS) {
    //   window.scrollTo(0, 0);
    // }
  }
  onConfirm(val: string) {
    this.district = val;
    this.togglePicker();
  }
  onCancel() {
    this.togglePicker();
  }
  togglePicker() {
    this.showPicker = !this.showPicker;
  }

  async onSubmit() {
    if (!this.checkForm()) {
      return;
    }
    // 获取封面以及视频地址
    const retImages = await (this.$refs
      .uploaderImage as Uploader).uploadToOss();
    const retVideo = await (this.$refs.uploaderVideo as Uploader).uploadToOss();
    const retRegister: any = await register({
      county: this.district,
      team: this.schoolName,
      class: this.grade,
      name: this.author,
      phone: this.phone,
      teacher: this.teacherName,
      title: this.title,
      introduction: (this.$refs.editor as SyEditor).content,
      cover: retImages[0],
      video: retVideo[0],
    });
    Toast(retRegister.msg);
    if (retRegister.code === 200) {
      this.reset();
    }
  }
  reset() {
    this.title = '';
    this.author = '';
    this.teacherName = '';
    this.schoolName = '';
    this.phone = '';
    this.district = '请选择区县';
    this.grade = '';
    (this.$refs.editor as SyEditor).clear();
    (this.$refs.uploaderImage as Uploader).reset();
    (this.$refs.uploaderVideo as Uploader).reset();
  }
}
